import { useWatchlist } from "@/context/WatchlistContext";
import { CloseOutlined } from "@ant-design/icons";
import { Button, Modal, Select, Typography, notification } from "antd";
import type { FC } from "react";
import { useState } from "react";

interface WatchlistModalProps {
  open: boolean;
  onClose: () => void;
}

const WatchlistSettingModal: FC<WatchlistModalProps> = ({ open, onClose }) => {
  const { watchlists, handleOpenModal, isUpdating, setSelectedWatchlist } = useWatchlist();
  const [selectedList, setSelectedList] = useState<string>();

  const handleCreateWatchlist = () => {
    onClose();
    handleOpenModal();
  };

  const handleSave = async () => {
    if (!selectedList) {
      notification.error({
        message: "Please select a watchlist",
      });
      return;
    }
    setSelectedWatchlist(selectedList);
  };

  const watchlistOptions =
    watchlists?.map(list => ({
      label: list.name,
      value: list.id,
    })) || [];

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={500}
      title="Custom market overview"
      centered
      closeIcon={<CloseOutlined />}
    >
      <div className="flex flex-col gap-4">
        <div className="grid grid-cols-2 gap-y-5 justify-end items-end gap-3">
          <div className="flex gap-4 flex-col">
            <Typography.Text>Select lists to pin</Typography.Text>
            <Select
              value={selectedList}
              style={{ width: "100%" }}
              onChange={value => setSelectedList(value)}
              options={watchlistOptions}
              size="large"
            />
          </div>

          <div className="flex gap-4">
            <Button type="primary" size="large" onClick={handleCreateWatchlist} className="flex-1">
              Create a watchlist
            </Button>
          </div>
        </div>
        <div className="flex gap-4 justify-end">
          <Button onClick={onClose} size="large" className="min-w-[120px]">
            Cancel
          </Button>
          <Button type="primary" onClick={handleSave} loading={isUpdating} size="large" className="min-w-[120px]">
            Save
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default WatchlistSettingModal;

